module.exports = __webpack_public_path__ + "img/DC1.4bf8dbf7.jpg";